module.exports = __webpack_public_path__ + "img/mode-prod--icon--active.3fc876cf.svg";